// @flow
import {BaseRepository} from "../../../../infrastructure/repositories/base-repository";
import {LocaleFactory} from "./locale.factory";
import {DomUtils} from "../../../../infrastructure/utils/dom-utils";
import {LoggerUtils} from "../../../../infrastructure/utils/logger/logger-utils";
import {SiteConfig} from "../../../../core/bootstrap/models/site-config";
import {LocaleApi} from "./locale.api";
import {DeviceStore} from "../../../../core/app/device.store";

export class LocaleRepository extends BaseRepository {
  static injectables = [DomUtils, LoggerUtils, SiteConfig, DeviceStore, LocaleApi, LocaleFactory];
}
